/** Inline SVG mark: a sky arc closed by code brackets. */
export function Logo({ size = 34 }: { size?: number }) {
  return (
    <svg
      className="logo"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="skLogoA" x1="4" y1="6" x2="44" y2="42" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--sky-ai)" />
          <stop offset="0.5" stopColor="var(--sky-teach)" />
          <stop offset="1" stopColor="var(--sky-avionics)" />
        </linearGradient>
      </defs>
      <rect x="1.5" y="1.5" width="45" height="45" rx="12" stroke="url(#skLogoA)" strokeWidth="2.5" />
      <path
        d="M17.5 15.5 11 24l6.5 8.5"
        stroke="url(#skLogoA)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.5 15.5 37 24l-6.5 8.5"
        stroke="url(#skLogoA)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 13.5 21 34.5"
        stroke="url(#skLogoA)"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
